module.exports = __webpack_public_path__ + "static/media/galerija_2017 (30).2e72a3fe.jpg";